export const PRODUCTS_LOADING = 'products/loading';
export const PRODUCTS_SUCESS = 'products/success';
export const PRODUCTS_ERROR ='products/error';
export const SORT_PRODUCTS = 'products/sort';
export const DESC = 'products/desc';
